import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useMemo } from 'react';
import { SSRConfig, useTranslation } from 'next-i18next';

import { BasicPage } from 'components/parts/BasicPage';
import { Content } from 'components/atoms/Content';
import styled from 'styled-components';
import xss from 'xss';

const StyledContent = styled(Content)`
    align-items: flex-start;
`;

function PrivacyPolicy(): React.ReactNode {
    const { t } = useTranslation('privacy-policy');
    const data = useMemo(() => {
        // This is not 100% necessarry but just in case
        const clean = xss(t('privacy-policy'));
        return {
            __html: clean,
        };
    }, [t]);
    return (
        <BasicPage>
            <StyledContent dangerouslySetInnerHTML={data}></StyledContent>
        </BasicPage>
    );
}

export async function getStaticProps({ locale }: { locale: string }): Promise<{ props: SSRConfig }> {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['privacy-policy', 'common'])),
        },
    };
}

export default PrivacyPolicy;
